<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/p-item-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Crear partidas</h4></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <div class="prospectos-table mt-3">
                <table class="stage-history-table">
                    <thead>
                        <tr>
                            <th>
                                <div class="th-content">
                                    <span>Nombre del producto</span>
                                </div>
                            </th>
                            <th>
                                <div class="th-content">
                                    <span>Cantidad</span>
                                </div>
                            </th>
                            <th>
                                <div class="th-content">
                                    <span>Precio producto</span>
                                </div>
                            </th>
                            <th>
                                <div class="th-content">
                                    <span>Total</span>
                                </div>
                            </th>
                            <th>
                                <div class="th-content">
                                    <span>Acciones</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(item of p_item; track item.item; let i = $index) {
                            <tr>
                                <td>
                                    <input 
                                        type="text" 
                                        class="td-input" 
                                        placeholder="Ingrese el nombre"
                                        [(ngModel)]="item.nombre">
                                </td>
                                <td>
                                    <input 
                                        type="text" 
                                        class="td-input" 
                                        placeholder="Ingrese la cantidad"
                                        [(ngModel)]="item.cantidad">   
                                </td>
                                <td>
                                    <input 
                                        type="number" 
                                        class="td-input" 
                                        placeholder="Ingrese valor"
                                        [(ngModel)]="item.precio"
                                        (input)="calculateTotal(i)"
                                        min="0"
                                        step="0.01">
                                </td>
                                <td>
                                    <span>{{item.cantidad * item.precio }}</span>
                                </td>
                                <td style="display: flex; justify-content: center; align-items: center;">
                                    <button
                                        class="btn-delete-item" 
                                        (click)="removePartida(i)"
                                        [disabled]="p_item.length === 1"
                                        title="Eliminar partida">
                                        <img src="assets/svg/delete-icon-only.svg" alt="" class="center-svg">
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-end mt-3">
                <button class="btn btn-primary-outline-2" (click)="addPartida()">Agregar partida</button>
            </div>
            <hr class="mt-5 mb-5">
            <div class="d-flex flex-row justify-center gap-20 mt-2">
                <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                <button 
                    class="btn btn-primary-outline text-center" 
                    (click)="savePartidas();"
                    [disabled]="!hasValidPartidas()">
                    Guardar nueva partida
                </button>
        </div>
    </div>
</div>

